import { render, staticRenderFns } from "./menopauseheader.vue?vue&type=template&id=65a98d5c&scoped=true&"
import script from "./menopauseheader.vue?vue&type=script&lang=js&"
export * from "./menopauseheader.vue?vue&type=script&lang=js&"
import style0 from "./menopauseheader.vue?vue&type=style&index=0&id=65a98d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a98d5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a98d5c')) {
      api.createRecord('65a98d5c', component.options)
    } else {
      api.reload('65a98d5c', component.options)
    }
    module.hot.accept("./menopauseheader.vue?vue&type=template&id=65a98d5c&scoped=true&", function () {
      api.rerender('65a98d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/components/menopauseheader.vue"
export default component.exports